<template>
  <div v-if="dialog">
         <v-btn @click="$emit('on-close')" class="close" flat icon color="white" absolute right>
              <v-icon class="close-icon">close</v-icon>
            </v-btn>
  <v-dialog persistent :ref="reference" v-model="dialog" :max-width="maxWidth">
    <v-card v-if="steps[step]" class="vuetify-stepper-dialog" height="600" :dark="dark">
      <v-card-title class="stepper-title">
 <v-container grid-list-md text-xs-center>
    <v-layout row wrap>


        <v-layout row align-center justify-center>

          <v-flex 
            xs4
            text-xs-center
            layout
          >
<v-btn v-if="step > 0"  v-show="!steps[step].icon_hidden" @click="onLast()" class="button-left" color="primary" flat icon round>
<v-icon>arrow_back</v-icon>
</v-btn>
        </v-flex>
          <v-flex
            xs4
            text-xs-center
            layout
            align-center
            justify-center
          >

<v-progress-circular
      class="progress-circular-test"
      :size="28"
      :width="3"
      :rotate="-90"
      :value="step / (steps.length - 1) * 100"
      color="primary"
    ></v-progress-circular>
        </v-flex>
                  <v-flex
                  class="flex-button-right"
            xs4
            text-xs-center
            layout
          >
        <v-btn
                  v-if="(steps.length - step) > 1" @click="onNext()" v-show="!steps[step].button_hidden" class="button-right" outline round color="primary" dark right>{{ steps[step].text || text }}</v-btn>

        </v-flex>

      </v-layout>
</v-layout>
</v-container>
      </v-card-title>
      <v-card-text>
        <div class="headline reservation">{{ steps[step].title || '' }}</div>
        <span v-if="steps[step].subtitle" class="reservation-span section primary--text"><br>{{ steps[step].subtitle }}</span>
        <vuetify-form-creator
          ref="form_creator"
          :columns="'xs12 sm12 md12 lg12'"
          :items="steps[step].fields"
          v-model="steps[step].fields"
          :validate-on-changed="false"
          @on-click-button="onClickButton"
          @on-blur="onChange"
          @on-change="onChange"
          @on-add-item="onAddItem"
        ></vuetify-form-creator>
        </v-card-text>
    </v-card>

  </v-dialog>
</div>
</template>

<script>

'use strict'

import VuetifyFormCreator from '@/components/vuetify-form-creator/vuetify-form-creator'
export default {

  components:
  {
    VuetifyFormCreator
  },

  name: 'VuetifyStepperDialog',

  model: {
    prop: 'value',
    event: 'change'
  },

  props:
  {
    reference: {
      type: String,
      default: 'dialog_confirm',
      required: false
    },
    value: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: Number,
      default: 290,
      required: false
    },
    headline: {
      type: String,
      default: 'Delete element?',
      required: false
    },
    text: {
      type: String,
      default: 'Siguiente',
      required: false
    },
    cancel: {
      type: String,
      default: 'Cancel',
      required: false
    },
    confirm: {
      type: String,
      default: 'Confirm',
      required: false
    },
    dark: {
      type: Boolean,
      default: false,
      required: false
    },
    dialog: {
      type: Boolean,
      default: true,
      required: false
    },
    items: {
      type: Array,
      default: null,
      required: true
    }
  },

  data: () => ({
    progress: 50,
    step: 0,
    isValid: false,
    steps: [
      {
        fields: []
      }
    ]
  }),

  methods:
  {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onNext () {
      this.isValid = this.$refs.form_creator.validateForm()
      if (this.isValid) {
        this.nextStep()
      }
      this.$emit('on-next-step', this.steps[this.step], this.step, this.isValid)
    },

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onLast () {
      this.lastStep()
      this.$emit('on-last-step', this.steps[this.step], this.step, this.isValid)
    },

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onAddItem (...params) {
      this.$emit('on-add-item', ...params)
    },

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    nextStep () {
      if (this.steps[this.step + 1]) {
        this.step++
      }
    },

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    lastStep () {
      if (this.steps[this.step - 1]) {
        this.step--
      }
    },

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onClickButton (item) {
      this.$emit('on-click-button', item, this.isValid)
    },

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onChange (...params) {
      console.log(...params)
      this.$emit('on-change', ...params)
    }
  },

  watch: {
    items: {
      handler: function (newVal) {
        this.steps = newVal
      },
      deep: true
    }
  }
}
</script>

<style lang="sass">

.vuetify-stepper-dialog
  height: 100%
  max-height: 80%

.overlay--active:before
  opacity: 0.92

.app-icon
  background: #3F51B5

.flex-button-right
  display: inline-block

.button-right
  float: right
  right: -19px

.button-left
  margin-left: -8px
  margin-top: -0px

.button-left > div > i
  font-size: 28px

.stepper-title
  margin-top: -9px !important

.progress-circular-test
  margin-left: 8px;

.reservation
  margin-left: 21px

.reservation-span
  margin-left: 21px
  display: block
  font-size: 17px

.close
  z-index: 9999999999 !important
  top: 0
  margin: 30px 18px 0 26px

.close-icon
  font-size: 50px
</style>



// WEBPACK FOOTER //
// src/components/vuetify-stepper-dialog.vue